import { combineReducers } from 'redux';
import { headerMenuReducer } from 'framework/ui/menu';
import { authenticatedUserReducer } from 'infrastructure/security/authentication/authenticatedUserService';
import authenticationTokenReducer from 'infrastructure/security/authentication/tokenprovider/authenticationTokenReducer';
import artifactsReducer from 'domain/documents/artifact/artifactsReducer';
import employeeNamesReducer from 'domain/people/employee/shared/employeeNamesReducer';
import { oneStopSettingsReducer } from 'domain/gpo/oneStop/List/Settings/useOneStopSettings';
import { journalEntriesSettingsReducer } from 'domain/finance/journalEntry/shared/Settings/useJournalEntriesSettings';
import { applicationsSettingsReducer } from 'domain/recruiting/applications/List/GroupedApplicationList/Settings/useApplicationsSettings';
import { purchaseOrderSettingsReducer } from 'domain/finance/purchaseOrder/shared/Settings/usePurchaseOrderSettings';
import { payrollReportsSettingsReducer } from 'domain/finance/payroll/generatedPayrolls/shared/Settings/usePayrollReportSettings';
import { authorizationReducers } from 'framework/authorization';
import { salesReducer } from 'domain/sales/salesService';
import { recruitersReducer } from 'domain/recruiting/recruiterService';
import { dataTimerReducer } from 'framework/ui/DataTimer';
import { reducer as pageLoadReducer } from 'infrastructure/security/audit/pageLoad';
import { messageReducer } from 'framework/ui/Message';
import { cacheReducer } from 'framework/cache';
import { sendEmailReducer } from 'infrastructure/email/sendEmail/sendEmailService';
import { notificationsReducer } from 'infrastructure/notification/redux/reducer';
import { projectsSettingsReducer } from 'domain/shared/project';

const rootReducer = combineReducers({
  auth: authenticatedUserReducer,
  authToken: authenticationTokenReducer,
  artifacts: artifactsReducer,
  employeeNames: employeeNamesReducer,
  oneStopSettings: oneStopSettingsReducer,
  journalEntriesSettings: journalEntriesSettingsReducer,
  projectsSettings: projectsSettingsReducer,
  applicationsSettings: applicationsSettingsReducer,
  purchaseOrderSettings: purchaseOrderSettingsReducer,
  payrollReportsSettings: payrollReportsSettingsReducer,
  authorization: authorizationReducers,
  message: messageReducer,
  sales: salesReducer,
  recruiters: recruitersReducer,
  cache: cacheReducer,
  pageLoad: pageLoadReducer,
  sendEmail: sendEmailReducer,
  timers: dataTimerReducer,
  headerMenu: headerMenuReducer,
  notifications: notificationsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
